import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
// import { Link } from "react-router-dom";
import Listing from "../components/Listing/listing";
import ListingModal from "../components/Modal/ListingModal";
import { AppContext } from "../AppContext";

export const MyPosts = () => {
    const [userPosts, setUserPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { userID, token, port, addAlert } = useContext(AppContext);    
    const [selectedPost, setSelectedPost] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const fetchUserPosts = async () => {
            setIsLoading(true);
            axios.get(`${port}/posts/user/${userID}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((response) => {
                setUserPosts(response.data);
            })
            .catch((error) => {
                addAlert('Failed to fetch user posts', 'danger');
            })
            .finally(() => {
                setIsLoading(false);
            });
        };
        fetchUserPosts();
    }, [addAlert, port, token, userID]);

    const handleListingClick = (post) => {
        setSelectedPost(post);
        setShowModal(true);
    };

    const handleDelete = async (postId) => {
        axios.delete(`${port}/posts/${postId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        .then(() => {
            setUserPosts(userPosts.filter(post => post._id !== postId));
            addAlert('Post deleted successfully', 'success');
        })
        .catch(() => {
            addAlert('Failed to delete post', 'danger');
        });
    };

    return (
        <div className="container mt-4">
            <h1 className="text-center mb-4">My Listings</h1>
            {isLoading ? (
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <div className="row">
                    {userPosts.length > 0 ? (
                        userPosts.map((post) => (
                            <div className="col-md-4 mb-4" key={post._id}>
                                <div className="listing-wrapper">
                                    <Listing 
                                        post={post} 
                                        showEditButton={true}
                                        showDeleteButton={true}
                                        onClickListing={handleListingClick}
                                        onDelete={handleDelete}
                                    />
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center">No listings available at the moment.</p>
                    )}
                </div>
            )}
            {selectedPost && (
                <ListingModal 
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    post={selectedPost}
                />
            )}
        </div>
    );
};
